import type { ComponentProps, FC } from "react";
import { Platform, type PlatformValue } from "shared";
import { Icon, IconSVG } from "./Icon";

interface PlatformProps {
	value: Platform | PlatformValue;
	size?: ComponentProps<typeof Icon>["size"];
}

const icons: Record<Platform, ComponentProps<typeof Icon>["name"]> = {
	[Platform.FACEBOOK]: IconSVG.Facebook,
	[Platform.THREADS]: IconSVG.BrandThreads,
	[Platform.INSTAGRAM]: IconSVG.Instagram,
	[Platform.LINKEDIN]: IconSVG.LinkedIn,
	[Platform.WORDPRESS]: IconSVG.Wordpress,
	[Platform.CUSTOM_BLOG]: "text_ad",
	[Platform.GOOGLE_BUSINESS]: IconSVG.Google,
	[Platform.YOUTUBE]: IconSVG.YouTube,
	[Platform.TIKTOK]: IconSVG.TikTok,
	[Platform.X]: IconSVG.BrandX,
};

export const PlatformIcon: FC<PlatformProps> = ({ value, size = 24 }) => {
	return <Icon name={icons[value]} size={size} />;
};
